import { Stack, Typography } from '@mui/material';
import { Theme, useTheme } from '@mui/material/styles';
import { Trans } from 'react-i18next';

import { ProgressDots } from '@/components/DataDisplay/Indicator/ProgressDots';
import { Screen } from '@/components/Layout/Screen';

import { useAppSelector } from '@/hooks/redux';
import { useTranslate } from '@/hooks/useTranslate';

import { MinorBasicInfoForm } from '@/pages/onboarding/minor-basic-information/components/MinorBasicInfoForm';

import { selectConfigsState } from '@/redux/configs/selectors';
import { selectOperationUser } from '@/redux/operation/selectors';

import { DocumentSection, DocumentType } from '@/types/document';

import { findLatestActiveDoc } from '@/utils/document';
import { PROGRESS_STEPS } from '@/utils/progressSteps';

export default function MinorBasicInfoScreen() {
  const theme = useTheme();
  const { language } = useTranslate();
  const minor = useAppSelector(selectOperationUser);
  const isFamilyBook =
    useAppSelector(selectConfigsState).isoCode === 'SUR' &&
    findLatestActiveDoc(minor?.documents ?? [], DocumentSection.Identity)
      ?.docType === DocumentType.FamilyBook;
  return (
    <Screen
      header={{
        centerSlot: !isFamilyBook && (
          <ProgressDots {...PROGRESS_STEPS.basicInfoStep} />
        ),
        bgColor: (theme: Theme) => theme.palette.background.paper,
      }}
      center
      bgColor={(theme: Theme) => theme.palette.background.paper}
    >
      <Stack direction="column" gap={1} mt={1}>
        <Trans
          lang={language}
          i18nKey="createNewAccount.basicInfo.minor.body"
          components={{
            br: <div />,
            a1: <Typography variant="h3" textAlign="center" />,
            a2: (
              <Typography
                variant="h3"
                component="span"
                color={theme.palette.primaries[500]}
                mb={3}
              />
            ),
          }}
        />
        <MinorBasicInfoForm />
      </Stack>
    </Screen>
  );
}
